"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagePropsApollo = exports.APOLLO_STATE_PROP_NAME = void 0;
const react_1 = require("react");
const libs_next_utils_1 = require("@hotelplan/libs.next-utils");
const apolloClient_1 = require("./apolloClient");
exports.APOLLO_STATE_PROP_NAME = `_astt`;
const stateApolloPropGetter = (0, libs_next_utils_1.createPagePropGetter)(exports.APOLLO_STATE_PROP_NAME);
function usePagePropsApollo(pageProps, config, apolloClientReplacement) {
    const state = stateApolloPropGetter(pageProps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const store = (0, react_1.useMemo)(() => apolloClientReplacement || (0, apolloClient_1.initializeApollo)(state, config), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]);
    return store;
}
exports.usePagePropsApollo = usePagePropsApollo;
//# sourceMappingURL=apolloProp.utils.js.map